module.exports = __webpack_public_path__ + "media/images/banner/klook/sp/rental-o_360_360_zh-hans-7a9b25d2fa8adf69e14b5453f8610c8b.jpg";